import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

// Horizontal scale (2.0 → 5.0) placing the student's grade among the class:
// a red→green track, a dot at the student's grade, a marker at the class average.
const GradeScale = ({ grade, classAverage, min = 2.0, max = 5.0 }) => {
    const pct = (v) => Math.min(100, Math.max(0, ((v - min) / (max - min)) * 100));
    return (
        <div style={{ padding: '6px 6px 0' }}>
            <div
                style={{
                    position: 'relative',
                    height: 10,
                    borderRadius: 6,
                    background: 'linear-gradient(90deg, #fca5a5 0%, #fcd34d 45%, #86efac 100%)',
                }}
            >
                {classAverage != null && (
                    <div
                        style={{
                            position: 'absolute',
                            left: `${pct(classAverage)}%`,
                            top: -5,
                            bottom: -5,
                            width: 2,
                            background: 'var(--wsb-text)',
                            opacity: 0.55,
                            transform: 'translateX(-1px)',
                        }}
                    />
                )}
                <div
                    style={{
                        position: 'absolute',
                        left: `${pct(grade)}%`,
                        top: '50%',
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        background: '#1890ff',
                        border: '3px solid #fff',
                        boxShadow: '0 2px 8px rgba(24,144,255,.55)',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 9 }}>
                <Text style={{ fontSize: 11.5, color: 'var(--wsb-muted)' }}>{min.toFixed(1)}</Text>
                {classAverage != null && (
                    <Text style={{ fontSize: 11.5, color: 'var(--wsb-muted)' }}>średnia grupy {classAverage}</Text>
                )}
                <Text style={{ fontSize: 11.5, color: 'var(--wsb-muted)' }}>{max.toFixed(1)}</Text>
            </div>
        </div>
    );
};

export default GradeScale;
